import React from 'react';

import {formatDateTime} from 'utils/datetime';

import rightArrow from './assets/tail-right.svg';

import './styles.css';

const InfoSection = ({roomMove: {oldAllocation, newAllocation, booking}}) => {
  return (
    <div className="InfoSection">
      <div className="data">
        <div className="section">
          <div className="header">From</div>
          <div className="text">{oldAllocation.room.roomNumber}</div>
        </div>

        <div className="section arrow">
          <img src={rightArrow} alt="rightArrow" />
        </div>
        <div className="section">
          <div className="header">To</div>
          <div className="text">{newAllocation.room.roomNumber}</div>
        </div>
        <div className="section">
          <div className="header">Access new room</div>
          <div className="text">{formatDateTime(newAllocation.startDate)}</div>
        </div>
        <div className="section">
          <div className="header">Vacate old room</div>
          <div className="text">{formatDateTime(oldAllocation.endDate)}</div>
        </div>
        <div className="section">
          <div className="header">Booking Duration</div>
          <div className="text">{booking.bookingDuration}</div>
        </div>
        <div className="section">
          <div className="header">Organization</div>
          <div className="text">{booking.bookingOrganisation || 'N/A'}</div>
        </div>
      </div>
    </div>
  );
};

export default InfoSection;
